import { render, staticRenderFns } from "./payman-filter.vue?vue&type=template&id=6ed55ce6&"
import script from "./payman-filter.vue?vue&type=script&lang=js&"
export * from "./payman-filter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports